import React from "react";

export type ToggleButtonProps = {
  checked?: boolean;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const ToggleButton = ({
  checked,
  className,
  onChange,
  disabled,
}: ToggleButtonProps) => {
  return (
    <input
      checked={checked}
      type="checkbox"
      className={`toggle toggle-primary ${className}`}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default ToggleButton;
